module.exports = __webpack_public_path__ + "img/ac2.ae201089.jpg";